import { h } from "preact";
import Picture from "./Picture";
import { css } from "emotion";

const eventCharity = css({
  padding: 20,
  textAlign: "center",
  border: "1px solid #DEDEDE",
  borderRadius: 4,
  color: "#323232",
  textDecoration: "none",
  display: "block"
});

const supportingMsg = css({
  fontWeight: 600,
  fontSize: 14,
  borderBottom: "solid 2px #dedede",
  color: "#323232 !important",
  display: "inline-block",
  padding: "0 0 4px 0",
  margin: "0 0 4px 0"
});

const charityName = css({
  color: "#5a626c",
  marginBottom: 8,
  fontSize: 16,
  fontWeight: 600,
  textTransform: "upperCase"
});

const impactMsg = css({
  marginBottom: 0,
  fontSize: 16,
  color: "#323232 !important"
});

const roundImg = css({
  overflow: "hidden",
  borderRadius: 120,
  height: 120,
  width: 120
});

const imageWrapper = css({
  height: 120,
  margin: "0px auto",
  marginBottom: 16
});

const EventCharity = ({ charity }) => {
  const impactString = charity.impactCreated
    ? charity.impactCreated
    : charity.oneLiner;
  return (
    <a href={charity.website} className={eventCharity}>
      <div
        className={css([
          imageWrapper,
          css({ width: charity.impactCreated ? 120 : 100 })
        ])}
      >
        {charity.impactCreated ? (
          <div className={roundImg}>
            <Picture
              alt={charity.name}
              img={charity.logo}
              width={120}
              height={120}
            />
          </div>
        ) : (
          <Picture alt={charity.name} img={charity.logo} width={100} />
        )}
      </div>
      <h3 className={supportingMsg}>Your booking fee is supporting</h3>
      <h2 className={charityName}>{charity.name}</h2>
      <p className={impactMsg}>{impactString}</p>
    </a>
  );
};
export default EventCharity;
